import React from 'react';

const Home: React.FC = () => {

  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center" style={{
      background: '#2E5A8A',
      fontFamily: 'monospace, "Courier New", "Lucida Console", Monaco, "Bitstream Vera Sans Mono", "Liberation Mono", "Nimbus Mono L", "DejaVu Sans Mono", "FreeMono", "Andale Mono", "Lucida Sans Typewriter", "Courier", monospace',
      margin: 0,
      padding: 0,
      color: 'white'
    }}>
      {/* Main Content */}
      <div className="text-center px-4 sm:px-6 py-8 sm:py-12 max-w-4xl mx-auto">
        {/* Bio Section */}
        <div className="text-center mb-6 sm:mb-8">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 retro-cursor retro-text" style={{
            textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
            letterSpacing: '1px',
            lineHeight: '1.1'
          }}>
            ⛓️ LINK THE GAP ⛓️
          </h1>
          
          <div className="text-base sm:text-lg md:text-xl mb-4 sm:mb-6 text-gray-300">
            <p className="mb-2">LINKTHEGAP AS IN MAKE CHANGE 🌐</p>
            <p className="text-sm sm:text-base md:text-lg text-gray-400 loading-text">Web-Tool Loading...</p>
          </div>

        </div>

        {/* Call to Action */}
        <div className="mt-8 sm:mt-12 text-center">
          <a 
            href="https://www.instagram.com/linkthegap/" 
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block px-4 sm:px-6 py-2 sm:py-3 text-base sm:text-lg font-bold text-white retro-text transition-all duration-300 hover:scale-105" 
            style={{ 
              background: '#000080',
              border: '2px solid #ffffff',
              textDecoration: 'none',
              textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
              letterSpacing: '1px',
              minWidth: '200px'
            }}
          >
            [ JOIN THE MOVEMENT ]
          </a>
        </div>
      </div>
    </div>
  );
};

export default Home;
